module.exports = __webpack_public_path__ + "static/media/URI_new_icon.92a9987c.svg";